import { memo, type ReactNode } from 'react';

import { ZapIcon } from '@air/design-icons';

import { UpsellPopover } from '~/components/ShareModal/components/UpsellPopover';

export type UpsellFlashIconButtonProps = {
  children: ReactNode;
};

/**
 * The flash affordance that sits BESIDE a locked control. Controls with an accessory slot of their
 * own carry the flash inside themselves instead (see ShareDesignImageButton) — both open the same
 * UpsellPopover.
 */
export const UpsellFlashIconButton = memo<UpsellFlashIconButtonProps>(({ children }) => (
  <UpsellPopover
    trigger={
      <button
        aria-label="Upgrade to unlock"
        className="flex items-center justify-center"
        data-testid="UPSELL_FLASH_ICON_BUTTON"
        type="button"
      >
        <ZapIcon
          aria-hidden
          className="cursor-pointer ads:text-icon-primary text-blue-9 ads:hover:text-icon-emphasis hover:text-blue-10"
          size="sm"
        />
      </button>
    }
  >
    {children}
  </UpsellPopover>
));

UpsellFlashIconButton.displayName = 'UpsellFlashIconButton';
